/**
 * Autogenerated file.
 * For adding or changing icons, see README.MD
 */
import React from 'react';
import { createIcon } from '../../icon/create-icon';
// Outline
const FlagOutline = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M3.75 20.524V4.774c6-4.5 10.5 4.5 16.5 0v11.25c-6 4.5-10.5-4.5-16.5 0"
})));
// Fill
const FlagFill = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M20.59 4.1a.738.738 0 0 0-.41-.08c-.14.02-.27.07-.38.15-2.65 1.99-4.9 1.03-7.5-.08-2.6-1.12-5.65-2.43-9 .08h-.01l-.04.03-.02.02-.02.03-.03.02-.02.03-.03.03c0 .01-.01.02-.02.03l-.02.04s-.01.01-.01.02c-.01.01-.01.03-.01.04-.01.01-.01.02-.02.04s-.01.02-.01.03-.01.02-.01.03-.01.02-.01.03-.01.03-.01.04v.05c0 .01-.01.02-.01.03v15.81a.75.75 0 0 0 1.5 0V16.4c2.52-1.69 4.7-.76 7.2.31 1.53.65 3.17 1.35 4.93 1.35 1.29 0 2.65-.37 4.07-1.44.09-.07.17-.16.22-.27.05-.1.08-.21.08-.33V4.77c0-.14-.04-.28-.11-.39a.802.802 0 0 0-.3-.28z"
})));
// DuoTone
const FlagDuotone = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M3.75 16.024c6-4.5 10.5 4.5 16.5 0V4.774c-6 4.5-10.5-4.5-16.5 0v11.25z",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M3.75 20.524V4.774c6-4.5 10.5 4.5 16.5 0v11.25c-6 4.5-10.5-4.5-16.5 0"
})));
/**
  Icon FlagIcon in maps group
*/
export const FlagIcon = createIcon('FlagIcon', 'flag', 'maps', FlagOutline, FlagFill, FlagDuotone, "0 0 24 24");